import {defaultHTTPRequests} from '../http-request-service';

export const paths = {
    GET_CURRENT_SURVEY: '/pml/survey/currentSurvey',
    POST_DITTE: '/pml/installer/survey',
    GET_LOGIN_MESSAGE: '/pml/alert/modal/message',
    POST_CREATE_SURVEY: '/pml/survey/createSurvey',
    GET_SURVEY: '/pml/survey/getSurvey?size=40',
    POST_SURVEY: '/pml/survey/saveSurvey',
    DISABLE_SURVEY : '/pml/survey/disableSurvey',
    GET_EXPORT_SURVEY: '/pml/survey/export',
    GET_EXPORT_SURVEY_CRUSCOTTO: '/pml/survey/exportCruscotto',
    GET_SURVEY_CRUSCOTTO: '/pml/survey/getSurveyCruscotto?size=1000',
    SEND_SURVEY_EMAIL: '/pml/survey/sendMailSurvey',
    GET_USER: '/pml/userByLoggedUserDepartmentAndWorkOrder',
    GET_EXPORT_DOWNLOAD_GUIDE: '/pml/filestorage/download/manual',
    GET_SURVEY_ACTIVE: '/pml/survey/active'
}

export const GET_SURVEY_ACTIVE = () => {
    return defaultHTTPRequests("GET", paths.GET_SURVEY_ACTIVE, null);
}

export const GET_CURRENT_SURVEY = () => {
    return defaultHTTPRequests("GET", paths.GET_CURRENT_SURVEY, null);
}

export const POST_DITTE = (body) => {
    return defaultHTTPRequests('POST', paths.POST_DITTE, null, body);
}

export const GET_LOGIN_MESSAGE = () => {
    return defaultHTTPRequests('GET', paths.GET_LOGIN_MESSAGE);
}

export const POST_CREATE_SURVEY = (body) => {
    return defaultHTTPRequests('POST', paths.POST_CREATE_SURVEY, null, body);
}

export const GET_SURVEY = (filters) => {
    
    if(filters.sort === ","){
        filters = {...filters, sort: "schedaDiProvenienza,asc"}
    }
    return defaultHTTPRequests("GET", paths.GET_SURVEY, filters).then((data) => {
        let promise = new Promise((resolve, reject) => {
            data.data.data.content = data.data.data.content.map((el) => {
                return ({
                    ...el,
                    // eslint-disable-next-line
                    "dataGiacenzaSeriale": el && el.dataGiacenzaSeriale? el.dataGiacenzaSeriale.substring(0, 10) : null,
                    "codiceSap": el && el.codiceSap? el.codiceSap.substring(9) === ''? el.codiceSap : el.codiceSap.substring(9) : null,
                    "serialNumber": el && el.serialNumber === null? "NON SERIALIZZATO" : el.serialNumber,
                    "typology": el && el.typology === false? "PASSIVE" : "SPARE",
                    "semaforo": el && el.semaforo === "DOING"? "BOZZA" : el.semaforo === "DONE"? "COMPLETATO" : el.semaforo === "TODO"? "DA_COMPILARE" : el.semaforo
                    
                })
            })
            resolve(data);
        })
        return promise;
    })
}

export const GET_SURVEY_CRUSCOTTO = (filters) => {
    return defaultHTTPRequests("GET", paths.GET_SURVEY_CRUSCOTTO, filters).then((data) => {
        let promise = new Promise((resolve, reject) => {
            data.data.data.content = data.data.data.content.map((el) => {
                return ({
                    ...el,
                    // eslint-disable-next-line
                    // "dataGiacenzaSeriale": el && el.dataGiacenzaSeriale? el.dataGiacenzaSeriale.substring(0, 10) : null,
                    // "codiceSap": el && el.codiceSap? el.codiceSap.substring(9) : null,
                    // "serialNumber": el && el.serialNumber === null? "NON SERIALIZZATO" : el.serialNumber,
                    // "typology": el && el.typology === false? "PASSIVE" : "SPARE",
                    // "semaforo": el && el.semaforo === "DOING"? "BOZZA" : el.semaforo === "DONE"? "COMPLETATO" : el.semaforo === "TODO"? "NON_COMPLETATO" : el.semaforo
                    
                })
            })
            resolve(data);
        })
        return promise;
    })
}

export const POST_SURVEY = (body) => {
    return defaultHTTPRequests('POST', paths.POST_SURVEY, null, body);
}

export const DISABLE_SURVEY = () => {
    return defaultHTTPRequests('DELETE', paths.DISABLE_SURVEY, null, null);
}

export const GET_EXPORT_SURVEY = (params) => {
    let _params = {};
    if (params)
        Object.keys(params).forEach((value) => {
            if (params[value])
                _params[value] = params[value];
        });

    return defaultHTTPRequests('EXPORT', paths.GET_EXPORT_SURVEY, _params);
}

export const GET_EXPORT_SURVEY_CRUSCOTTO = (params) => {
    let _params = {};
    if (params)
        Object.keys(params).forEach((value) => {
            if (params[value])
                _params[value] = params[value];
        });

    return defaultHTTPRequests('EXPORT', paths.GET_EXPORT_SURVEY_CRUSCOTTO, _params);
}

export const SEND_SURVEY_EMAIL = (body) => {
    return defaultHTTPRequests('POST', paths.SEND_SURVEY_EMAIL, null, body);
}

export const GET_USER = (params) => {
    return defaultHTTPRequests("GET", paths.GET_USER, params);
}

export const GET_EXPORT_DOWNLOAD_GUIDE = () => {
    return defaultHTTPRequests("EXPORT", paths.GET_EXPORT_DOWNLOAD_GUIDE);
}
